/**
 * Mysterious-island expedition difficulty legibility — the spec's 4 fixed paliers.
 * Maps a tier key to an at-a-glance colour (green → red heat scale), a 1-4 level
 * (for the compact map marker badge) and the human label. Drives the map marker
 * difficulty badge AND the side-panel difficulty readout, so it reads the same
 * everywhere — mirroring how {@link dangerTier} drives the raid danger badge.
 */
export type ExpeditionTier = 'tres_facile' | 'facile' | 'moyen' | 'difficile'

export interface ExpeditionTierMeta {
  /** At-a-glance heat colour (hex; palette is partial so we use inline styles). */
  color: string
  /** 1-4 difficulty level, shown in the compact map marker badge. */
  level: number
  /** Human label ("Très facile" …). */
  label: string
}

export const EXPEDITION_TIER_META: Record<ExpeditionTier, ExpeditionTierMeta> = {
  tres_facile: { color: '#6EE7B7', level: 1, label: 'Très facile' },
  facile: { color: '#5FBDD0', level: 2, label: 'Facile' },
  moyen: { color: '#E5CC8F', level: 3, label: 'Moyen' },
  difficile: { color: '#F87171', level: 4, label: 'Difficile' },
}

/** Safe lookup that tolerates a null/unknown tier (returns null). */
export function expeditionTierMeta(tier: string | null | undefined): ExpeditionTierMeta | null {
  return tier && tier in EXPEDITION_TIER_META ? EXPEDITION_TIER_META[tier as ExpeditionTier] : null
}
